
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/software-suppliers-directory",
      function () {
        return require("private-next-pages/software-suppliers-directory.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/software-suppliers-directory"])
      });
    }
  